var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsAccompagnement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #bf764d;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 50.05,
    cy: 13.95,
    r: 13.95
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.03,29.79l.67.47.67-.47c.44-.31,10.86-7.76,10.86-14.25,0-3.78-2.84-6.86-6.34-6.86-2.22,0-4.07.97-5.19,2.55-1.12-1.58-2.97-2.55-5.19-2.55-3.5,0-6.34,3.07-6.34,6.86,0,6.5,10.42,13.94,10.86,14.25ZM24.51,10.98c2.37,0,4.03,1.66,4.03,4.03v.58h2.3v-.58c0-2.37,1.66-4.03,4.03-4.03,2.22,0,4.03,2.04,4.03,4.55,0,4.08-6.13,9.56-9.22,11.88-3.09-2.33-9.22-7.8-9.22-11.88,0-2.51,1.81-4.55,4.03-4.55ZM57.77,30.93c-1.15-1.04-2.63-1.55-4.17-1.5-1.54.07-2.97.74-4.01,1.89l-8.6,9.45c-.72-2.55-3.08-4.43-5.86-4.43H10.11c-3.18,0-5.76,2.59-5.76,5.76v16.13c0,3.18,2.58,5.76,5.76,5.76h25.87l22.21-24.93c2.1-2.35,1.92-6-.42-8.13h0ZM56.47,37.53l-21.53,24.16H10.11c-1.91,0-3.46-1.55-3.46-3.46v-16.13c0-1.91,1.55-3.46,3.46-3.46h25.02c2.09,0,3.79,1.7,3.79,3.78,0,1.87-1.4,3.48-3.23,3.75l-13.05,1.7.3,2.28,13.06-1.7c2.35-.34,4.25-2.02,4.94-4.2l10.36-11.39c.62-.69,1.48-1.09,2.41-1.13.93-.03,1.82.28,2.51.91,1.4,1.28,1.52,3.47.25,4.89Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsAccompagnement);
export default __webpack_public_path__ + "static/media/ICONS_Accompagnement.8e8746ac850e27732cb0bcb9dd981a78.svg";
export { ForwardRef as ReactComponent };